<template>
  <el-dialog
    custom-class="no-header-dialog "
    title=""
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="visibility"
    width="613px"
    append-to-body
  >
  <div class="py-3 px-3 flex">
    <div class="text-center">
      <p class=" text-black font-semibold text-medium-x mb-4">人脸识别验证</p>
      <p class="text-tip">
        为确保信息安全，需确认您的身份
        请使用“调研工厂调查员版”App<br>
        扫描下方二维码进行人脸识别验证
      </p>
      <div class="img-box">
        <vue-qr
          class="m-auto"
          :text="codeUrl"
          :margin="0"
          :size="200"
          style="display: block;"
        />
      </div>
    </div>
    <div class="line mx-10"></div>
    <div class="text-center">
      <p class="text-tip right-tip">如未安装“调研工厂调查员版”App
        请先扫描下方二维码下载 App
      </p>
      <div class="img-box investigator-img">
        <img src="~@/assets/img/appDownload/调查员二维码@2x.png" alt="" />
      </div>
    </div>
  </div>
  </el-dialog>
</template>

<script>
import VueQr from 'vue-qr'
import { getFaceVerifyLastRecord } from '@/api/auth'

export default {
  components: {VueQr},
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      codeUrl: 'http/survey?phone=' + this.$store.getters.userInfo.phone,
      timer: null
    }
  },
  computed: {
    visibility: {
      set(v) {
        this.$emit('update:visible', v)
      },
      get() {
        if(this.visible) {
          this.timer = setInterval(()=>{
            if(!this.timer) {
              return
            }
            this.getFaceVerify()
            
          }, 1000)
        }
        return this.visible
      }
    }
  },
  methods: {
    async getFaceVerify() {
      const record = await getFaceVerifyLastRecord()
      const update = new Date(record.data?.data?.lastFaceVerifyTime??'').getTime()
      const now = new Date().getTime()
      console.log('record', record)
      if(!update) {
        this.visibility = true
      }else {
        this.visibility = now - update > 3600000*4
      }
      console.log('this.visibility', this.visibility)
      if(!this.visibility) {
        this.$message.success('验证成功')
        this.timer = null
        clearInterval(this.timer)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-tip {
  width: 210px;
  @apply text-medium text-black text-center inline-block leading-24;
}
.right-tip {
  margin-top: 48px;
}
.line {
  width: 1px;
  background: #E5E5E5;
}
.img-box {
  width: 160px;
  height: 160px;
  @apply mt-4 my-0 mx-auto;
  img {
    @apply w-full;
  }
}
.investigator-img {
  width: 130px;
  height: 130px;
}
</style>